import { BackIcon } from '@euler/app/components/icons/BackIcon';
import { ErpEmployeeMappingScreen } from '@euler/app/flows/erp/pages/ErpEmployeeMappingScreen';
import { ErpEmployeeSelectorScreen } from '@euler/app/flows/erp/pages/ErpEmployeeSelectorScreen';
import { ErpLoginScreen } from '@euler/app/flows/erp/pages/ErpLoginScreen';
import { ErpManagementScreen } from '@euler/app/flows/erp/pages/ErpManagementScreen';
import { ErpOrderSyncScreen } from '@euler/app/flows/erp/pages/ErpOrderSyncScreen';
import { ErpProviderSelectionScreen } from '@euler/app/flows/erp/pages/ErpProviderSelectionScreen';
import { ErpSyncLogsScreen } from '@euler/app/flows/erp/pages/ErpSyncLogsScreen';
import { NavHeaderBg } from '@euler/app/flows/settings/components/NavHeaderBg';
import { MultilineHeaderTitle } from '@euler/components/MultilineHeaderTitle';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ScreenToParams, spreadScreens } from '@euler/functions/spreadScreens';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import {
  TransitionPresets,
  createStackNavigator,
} from '@react-navigation/stack';
import { memo } from 'react';

const Stack = createStackNavigator();

const Screens = {
  _erpManagement: ErpManagementScreen,
  _erpProviderSelection: ErpProviderSelectionScreen,
  _erpLogin: ErpLoginScreen,
  _erpEmployeeMapping: ErpEmployeeMappingScreen,
  _erpEmployeeSelector: ErpEmployeeSelectorScreen,
  _erpOrderSync: ErpOrderSyncScreen,
  _erpSyncLogs: ErpSyncLogsScreen,
};

export type ErpNavParams = ScreenToParams<typeof Screens>;

export const ErpFlow = wrapNavigatorScreen(
  () => {
    return <Content />;
  },
  {
    headerShown: false,
  },
);

const Content = memo(() => {
  const { rpx } = useResponsiveContext();
  return (
    <Stack.Navigator
      initialRouteName="_erpManagement"
      screenOptions={{
        ...TransitionPresets.SlideFromRightIOS,
        headerMode: 'float',
        headerTitleAlign: 'center',
        headerBackTitle: ' ',
        headerTitleStyle: {
          fontSize: rpx(18),
          fontFamily: FontFamily.NotoSans.Bold,
          color: '#fff',
        },
        cardStyle: {
          backgroundColor: '#f7f7f7',
        },
        headerTitle: MultilineHeaderTitle,
        headerBackImage: () => <BackIcon fill="#fff" />,
        headerBackground: NavHeaderBg,
      }}
    >
      {spreadScreens(Stack.Screen, Screens)}
    </Stack.Navigator>
  );
});
